import React from "react";
import Box from "@mui/material/Box";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";

import { getImage, sortImages } from "../../../utils/images";

var ImageFieldsCache = {};

const styles = {
  container: maxWidth => ({
    display: "flex !important",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    "& img": {
      maxWidth: maxWidth,
      maxHeight: "100%",
    },
    "& .lazy-load-image-background": {
      display: "flex",
      alignItems: "center",
      width: "100%",
      height: "100%",
    },
  }),
  noImage: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

const ImageField = ({ entity, maxWidth = 100, onDoubleClick, onClick }) => {
  const images = sortImages(entity?.images);
  const src = images.length ? getImage(images[0].url, "width", 200) : undefined;
  const buttonProps = { onDoubleClick, onClick };

  return (
    <>
      {src ? (
        ImageFieldsCache[src] === true ? (
          <Box component="span" sx={styles.container(maxWidth)} {...buttonProps}>
            <img style={{ maxWidth }} src={src} />
          </Box>
        ) : (
          <Box component="span" sx={styles.container(maxWidth)} {...buttonProps}>
            <LazyLoadImage
              afterLoad={() => (ImageFieldsCache[src] = true)}
              effect="opacity"
              src={src}
            />
          </Box>
        )
      ) : (
        <Box
          sx={styles.noImage}
          onDoubleClick={e => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          No image
        </Box>
      )}
    </>
  );
};

export default ImageField;
